import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Col,
  Row,
  notification,
  Drawer,
  Button,
  Popconfirm,
} from "antd";
import {
  PlusOutlined,
  BarsOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import TenantPaymentAccountAddForm from "../Forms/TenantPaymentAccountAddForm";
import TenantPaymentAccountUpdate from "../Forms/TenantPaymentAccountUpdate";
import { useMediaQuery } from "react-responsive";
import RequestHandler from "../../util/RequestHandler";

const openNotificationWithIconDelete = (type) => {
  notification[type]({
    message: "BAŞARILI",
    description: "Silme işlemi başarı ile gerçekleşti.",
    duration: 2,
  });
};
const openNotificationWithIconWarningDelete = (type) => {
  notification[type]({
    message: "HATA",
    description: "Silme işlemi sırasında bir hata oluştu.",
    duration: 2,
  });
};

const TenantPaymentAccount = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-device-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({ query: "(max-device-width: 1224px)" });

  const [tenantPaymentAccounts, setTenantPaymentAccounts] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [dataState, setDataState] = useState([{ skip: 0, take: 10 }]);
  const [isDefault, setIsDefault] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [bankBranchDropdownUpdate, setBankBranchDropdownUpdate] = useState([]);
  const [firmDropdown, setFirmDropdown] = useState([]);
  const [tenantPaymentAccountId, setTenantPaymentAccountId] = useState("");
  const [take, setTake] = useState(20);
  const [skip, setSkip] = useState(0);
  const [bankBranchName, setBankBranchName] = useState("");
  const [iban, setIban] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [bankBranchId, setBankBranchId] = useState("");
  const [bankId, setBankId] = useState("");
  const [name, setName] = useState("");
   const [currencyId, setCurrencyId] = useState("");
  const [tenantAccountId, setTenantAccountId] = useState(null);


  const [showIban, setShowIban] = useState(true);
  const [isAkbankOnline, setIsAkbankOnline] = useState(false);

  useEffect(() => {

    RequestHandler.get(
        `/TosBankInfo?$filter=id eq ${props.match.params.id}`
      ).then((response) => {
       const isAkbankWs = response.value[0].isUseWebService && response.value[0].bankId === 46;
       setIsAkbankOnline(isAkbankWs);
       setShowIban((!response.value[0].isUseWebService && response.value[0].bankId !== 10) || isAkbankWs);
      });

    setTenantPaymentAccounts({
      tenantPaymentAccounts,
      loading: true,
    });
    RequestHandler.get(`/TenantPaymentAccount?$filter=bankId eq ${props.match.params.bankId} and bankInfoId eq ${props.match.params.id}&$count=true&$skip=${skip}&$top=${take}`).then((response) => {
      setTenantPaymentAccounts({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  }, [skip, take]);

  const showDrawerUpdate = (value) => {
    RequestHandler.get(`/Firm`).then((response) => {
      setFirmDropdown(response.value);
    });

    RequestHandler.get(`/TenantPaymentAccount/getbyid/${value}`).then((response) => {
      setBankBranchId(response.bankBranchId);
      setBankBranchName(response.bankBranchId);
      setBankId(response.bankId.toString());
      setName(response.name);
      setAccountNumber(response.accountNumber);
      setIban(response.iban);
      setIsDefault(response.isDefault);
      setTenantPaymentAccountId(value);
      setVisibleUpdate(true);
      setCurrencyId(response.currencyId);
      setTenantAccountId(response.tenantAccountId || null);

      RequestHandler.get(`/BankBranch/GetBranchForBankAccount?bankId=${response.bankId}`).then((res) => {
        setBankBranchDropdownUpdate(res);
      });
      if (response.bankBranchId !== undefined && response.bankBranchId !== null && response.bankBranchId !== "") {
        RequestHandler.get(`/BankBranch/GetBranchForBankAccountName?bankId=${response.bankId}&accountId=${response.bankBranchId}`).then((res) => {
          setBankBranchName(res.name);
          setBankBranchId(res.id);
        });
      }
    });
  };

  const onClose = () => {
    setVisible(false);
    setVisibleUpdate(false);
  };

  const reList = () => {
    setTenantPaymentAccounts({
      tenantPaymentAccounts,
      loading: true,
    });
    RequestHandler.get(`/TenantPaymentAccount?$filter=bankId eq ${props.match.params.bankId} and bankInfoId eq ${props.match.params.id}&$count=true&$skip=${skip}&$top=${take}`).then((response) => {
      setTenantPaymentAccounts({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const getData = (val) => {
    if (val === "success") {
      reList();
      setVisibleUpdate(false);
      setVisible(false);
    }
  };

  const onCloseUpdate = () => {
    setVisibleUpdate(false);
  };

  const handleDelete = (key) => {
    RequestHandler.delete(`/TenantPaymentAccount?id=${key}`, undefined, false, { rawResponse: true }).then((res) => {
      if (res.status == 204 || res.status == 200) {
        openNotificationWithIconDelete("success");
        setTenantPaymentAccounts({
          data: tenantPaymentAccounts.data.filter((item) => item.id !== key),
          total: tenantPaymentAccounts.total - 1,
          loading: false
        });
        if (tenantPaymentAccounts.data.filter((item) => item.id !== key).length == 0) {
          window.location.reload();
        }
      } else {
        openNotificationWithIconWarningDelete("error");
      }
    });
  };

  const paging = (p) => {
    setDataState((prevState) => {
      prevState.skip = (p.current - 1) * 20;
      setSkip(prevState.skip);
      return {
        prevState,
      };
    });
  };

  const columns = [
    {
      title: "BANKA",
      dataIndex: "bankName",
      key: "bankName",
      render: (text, row, index) => {
        return (
          <div style={{ width: 100 }}>
            {" "}
            <img src={row.bankLogo}></img>
          </div>
        );
      },
    },
    {
      title: "Hesap Adı",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "IBAN",
      dataIndex: "iban",
      key: "iban",
    },
    {
      title: "Hesap Numarası",
      dataIndex: "accountNumber",
      key: "accountNumber",
    },
    {
      title: "",
      dataIndex: "operation",
      align: "right",
      width: "10%",
      render: (text, record) =>
        tenantPaymentAccounts.data.length >= 1 ? (
          <a
            onClick={() => {
              showDrawerUpdate(record.id);
            }}
            style={{ color: "orange", fontSize: "130%" }}
          >
            <EditOutlined />
          </a>
        ) : null,
    },
    {
      title: "",
      dataIndex: "operation",
      width: "10%",
      render: (text, record) =>
        tenantPaymentAccounts.data.length >= 1 ? (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleDelete(record.id)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <DeleteOutlined />
            </a>
          </Popconfirm>
        ) : null,
    },
  ];

  return (
    <div>
      <Row>
        {isTabletOrMobileDevice && (
          <>
            <Col span={13}>
              <p style={{ fontSize: "120%" }}>
                <BarsOutlined /> ÖDEME HESAPLARI
              </p>
              <hr></hr>
              <br></br>
            </Col>
            <Col span={11}>
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  setVisible(true);
                }}
              >
                <PlusOutlined /> Ödeme Hesabı Ekle
              </Button>
            </Col>
          </>
        )}
        {isDesktopOrLaptop && (
          <>
            <Col span={20}>
              <p style={{ fontSize: "120%", marginTop: -9 }}>
                <BarsOutlined /> ÖDEME HESAPLARI
              </p>
            </Col>
            <Col span={4}>
              <Button
                type="primary"
                onClick={() => {
                  setVisible(true);
                }}
              >
                <PlusOutlined /> Ödeme Hesabı Ekle
              </Button>
            </Col>
          </>
        )}
      </Row>
      <Drawer
        title="Ödeme Hesabı Güncelle"
        width={500}
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ paddingBottom: 80, padding: 24 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <TenantPaymentAccountUpdate
          name={name}
          sendDataForUpdate={getData}
          firmAccountId={tenantPaymentAccountId}
          bankId={props.match.params.bankId}
          bankInfoId={props.match.params.id}
          iban={iban}
          bankBranchName={bankBranchName}
          accountNumber={accountNumber}
          isDefault={isDefault}
          currencyId={currencyId}
          showIban={showIban}
          isAkbankOnline={isAkbankOnline}
          tenantAccountId={tenantAccountId}
        />
      </Drawer>
      <Drawer
        title="Ödeme Hesabı Ekle"
        width={500}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80, padding: 24 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <TenantPaymentAccountAddForm bankId={props.match.params.bankId} bankInfoId={props.match.params.id} showIban={showIban} isAkbankOnline={isAkbankOnline} />
      </Drawer>
      <Row>
        {isDesktopOrLaptop && (
          <>
            <Col span={2}></Col>
            <Col span={20}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%" }}
                size="small"
                rowKey="Id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{ pageSize: 20, total: tenantPaymentAccounts.total }}
                dataSource={tenantPaymentAccounts.data}
                loading={tenantPaymentAccounts.loading}
              />
            </Col>
            <Col span={2}></Col>
          </>
        )}
        {isTabletOrMobileDevice && (
          <>
            <Col span={24}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", width: "100%", maxHeight: "100%" }}
                size="small"
                rowKey="Id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{ pageSize: 20, total: tenantPaymentAccounts.total }}
                dataSource={tenantPaymentAccounts.data}
                loading={tenantPaymentAccounts.loading}
              />
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default TenantPaymentAccount;
